module.exports = __webpack_public_path__ + "908e4d2e/img/grid-web-icon.d0395d64.svg";